import { IconDefinition, faLink, faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import CountUp from 'react-countup';
import { isNumber } from "../../util/generic";
import { Sections } from "../../util/types";

type HeadlineSize = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

interface InformationCardProps {
  text: string;
  value?: string | number | null;
  icon: string;
  navigate?: string;
  onClick?: () => void;
  headlineSize?: HeadlineSize;
  prefix?: string,
  suffix?: string,
  duration?: number,
  section?: Sections,
  activeSection?: Sections,
}

const MoreInfoIcon:React.FC<{ section?:Sections,
  activeSection?:Sections,
  navigate?:string,
  onClick?: () => void,
 }> = ({section, activeSection, navigate, onClick}) => {
  if(!(navigate || onClick)) {
    return null;
  }

  var styles:React.CSSProperties = {position:"absolute", right:"15px", bottom:"15px", fontSize:"12px"};
  var color:string = "#9d9d9d";

  if(navigate) {
    return <FontAwesomeIcon icon={faLink} size="1x" color={color} style={styles}/>
  }

  if(section === activeSection) {
    return <FontAwesomeIcon icon={faMinus} size="1x" color={color} style={styles}/>
  }

  return <FontAwesomeIcon icon={faPlus} size="1x" color={color} style={styles}/>
}

const InformationCard: React.FC<InformationCardProps> = ({
  text,
  value,
  icon,
  navigate,
  onClick,
  headlineSize = "h2",
  prefix=undefined,
  suffix=undefined,
  duration=4,
  section,
  activeSection
}) => {
  return (
    <div
      className={`card ${navigate || onClick ? "card-link" : ""}`}
      style={{ maxHeight: "9rem", minHeight: "8rem", position:"relative", filter:(section === activeSection && (navigate || onClick))? "brightness(92%)" : undefined}}
    >
      <div
        className="row card-body align-items-center text-center"
        onClick={onClick ? onClick : undefined}
      >
        <div className="col-xxl-3">
          <img src={icon} alt={text} style={{width:"100%", maxWidth:"34px"}}/>
        </div>
        <div className="col-xxl-9">
          <h5
            className={headlineSize}
            style={{ color: "#5780b5", fontWeight: "bold" }}
          >
            {
              isNumber(value) ?
                <CountUp
                end={Number(value)}
                duration={duration}
                separator=","
                prefix={prefix}
                suffix={suffix} /> : value
            }
          </h5>
          <h6 className="text-muted">{text}</h6>
        </div>
        
      </div>
      <MoreInfoIcon activeSection={activeSection} navigate={navigate} onClick={onClick} section={section} />
      {navigate && <Link to={navigate} />}
    </div>
  );
};

export default InformationCard;
